import React, { useState } from "react";
/** @jsxImportSource @emotion/react */
import "twin.macro";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { Input, Modal, Rate } from "antd";
import { useMutation } from "react-query";
import { isEmpty, Toast } from "../../lib/helpers/helpers";
import { ButtonLightPink } from "../../lib/styles/styleLibrary";
import { ratingFeedback } from "../../redux/actions/authentication";
import errorHandler from "../../redux/actions/errorHandler";
import { Loading } from "../Loading/Loading";
import { Wrapper } from "./component";

const Rating = ({
	showRating,
	setShowRating = () => {
		return null;
	},
}) => {
	const { TextArea } = Input;

	const [rf, srf] = useState({
		rating: 5,
		comment: "",
	});

	const { mutateAsync: handleRF, isLoading: rfLoading } =
		useMutation(ratingFeedback);

	const handleRatingFeedback = async () => {
		if (isEmpty(rf?.comment.trim())) {
			Toast.fire({
				icon: "question",
				title: `Say something nice, please...`,
			});
			return;
		}

		try {
			const res = await handleRF(rf);
			console.log(res);
			const { hasError, errors } = res.data;
			if (hasError) {
				return errorHandler(errors);
			}
			Toast.fire({
				icon: "success",
				title: `${res.message}\n ${res.data.comment}`,
			});
			setShowRating(false);
		} catch (err) {
			console.log("the rating error", err);
		}
	};

	return (
		<Wrapper>
			<Modal
				footer=""
				visible={showRating}
				centered
				closable={false}
				maskClosable={false}>
				<div
					tw="mb-4 h-8 w-8 px-2 py-2 bg-gray-100 rounded-full hover:(cursor-pointer border-2 border-solid border-purple-800) flex flex-col items-center justify-center"
					onClick={() => setShowRating(false)}>
					<ArrowLeftOutlined tw="hover:(text-purple-800 transform scale-125)" />
				</div>

				<h3 tw="font-semibold text-center text-xl opacity-80">
					Rate Wedding Story
				</h3>
				<div tw="mt-4! flex justify-center items-center mb-8!">
					<Rate
						allowHalf
						value={rf.rating}
						tw="text-appPink text-3xl! md:text-base inline-flex flex-nowrap"
						onChange={(val) => {
							srf(val);
						}}
					/>
				</div>
				<div tw="mt-4">
					<TextArea
						placeholder="Comment"
						autoSize={{ minRows: 2 }}
						tw="mb-4 text-xs p-3 rounded-lg"
						value={rf.post_text}
						onChange={(e) =>
							srf({
								...rf,
								comment: e.target.value,
							})
						}
					/>
				</div>
				<div tw="flex justify-center items-center w-full mt-4">
					<ButtonLightPink
						tw="w-full! h-12!"
						onClick={() => {
							handleRatingFeedback();
						}}>
						{rfLoading ? <Loading /> : "Submit"}
					</ButtonLightPink>
				</div>
			</Modal>
		</Wrapper>
	);
};

export default Rating;
